import { useEffect} from 'react';
import Router from 'next/router'
import Button from '@material-ui/core/Button'; 
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography'; 
import Container from '@material-ui/core/Container'; 
import TypographyBorder from '../components/typography';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Appbar from '../components/appBar';
import Head from "next/head";
import Footer from "../components/footer";
import WidgetWa from "../components/widgetWa";
import useStyles from '../styles/pricingStyle';

const tiers = [
  {
    title: 'Plan Mensual',
    price: '15.000',
    description: [
      'Proyectos Ilimitados', 
      'Reportes en Excel', 
      'Reportes en PDF', 
      'Metadatos del Proyecto',  
      'Imagenes de Proyecto', 
    ],
    buttonText: 'Ir',
    buttonVariant: 'outlined',
    plan: "monthly"
  }, 
]; 


export default function Planes() {


  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));
  const classes = useStyles(); 

  useEffect(() => { 
    Router.prefetch('/inscription')
  }, []) 

  const goto = (url) => Router.push(url)


  return (
    <>
      <Head>
        <title>Planes</title>
        <link rel="icon" href="/favicon.ico" /> 
        <meta charSet="utf-8" />
        <meta itemProp="description" content="Conozca los Planes que CIDU S.A.S.tiene para usted y su productividad"/>
        <link rel="canonical" href="https://cidu.com.co/planes" />
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
      </Head> 
      <Grid style={{ height: '-webkit-fill-available'}}>
        <Appbar/>
        <Grid className={classes.root} >
          <Container className={classes.backgrounplans}  maxWidth={false}>
          <Container maxWidth="sm" component="main" className={classes.heroContent}>
            <TypographyBorder variant={matches ? "h3": "h2"} marked="center" align="center" component="h1" className={classes.heroContentTitle}>
              Planes
            </TypographyBorder>
            <Typography variant="h5" align="center"  component="p" className={classes.heroContentSubtitle}>
              Seleccione un plan adecuado para su negocio y solo pague por lo que use. 
            </Typography>
          </Container>
          <Container  className={classes.heroContentFooter} >
            <Grid container spacing={4} alignItems="flex-end" justify="center" direction="row">

              {tiers.map((tier) => (
                <Grid item key={tier.title} xs={11} sm={7} md={5}>
                  <Card  className={classes.cardShadow} >
                    <CardHeader
                      title={<Typography variant="h5" align="center" className={classes.titlePlan}>
                      {tier.title}
                      </Typography> } 
                      subheader={tier.subheader}
                      disableTypography
                      className={classes.cardHeader}/>

                    <CardContent className={classes.cardContent}>
                      <div className={classes.cardPricing}>
                        <Typography component="h2" variant="h3" color="textPrimary" className={classes.tittle}>
                          ${tier.price}
                        </Typography>
                        <Typography variant="h6" color="textSecondary" className={classes.tittle}>
                          /proyecto
                        </Typography>
                      </div>
                      <ul>
                        {tier.description.map((line, index) => (
                          <Typography component="li" variant="subtitle1"  className={classes.carddescription} key={index.toString()}>
                            {line}
                          </Typography>
                        ))}
                      </ul>
                    </CardContent>
                    <CardActions className={classes.bottomMargin}>
                      <Button fullWidth variant={tier.buttonVariant} className={classes.bottomPrimary} onClick={() => goto('/inscription')} >
                        {tier.buttonText}
                      </Button>
                    </CardActions>
                    <Typography className={classes.cardterm} color="textSecondary" >
                      *sin IVA incluido - Precio en Pesos COP
                    </Typography>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Container>
          <Container  component="main" className={classes.subContent}>
            <Typography variant="h5" align="center"  component="h1" className={classes.subttext}>
              Si necesita un plan diferente para usted o su empresa no dude en <a onClick={() => goto('/contacto')}>contactarnos</a>.
            </Typography>
          </Container>
          </Container>
        </Grid>
        <Footer/>
      </Grid>
      <WidgetWa link={"https://wa.me/573014606980/?text=Hola%20CIDU,%20quiero%20contactarme%20con%20Ustedes!"}/>
    </>
  );
}